import { Link, LinkProps } from '@chakra-ui/react'
import { NextLinkProps } from '@src/components/sco/utilities/NextLink'
import { forwardRef } from 'react'

export type TextLinkProps = NextLinkProps & LinkProps

export const TextLink = forwardRef<HTMLAnchorElement, TextLinkProps>((props, ref) => (
  <Link ref={ref} {...props} borderBottom={'1px dotted'} />
))
